import { Link } from "react-router-dom";

const formatArticleDate = (value) => {
    if (!value) return "";
    try {
        return new Date(value).toLocaleDateString(undefined, {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    } catch {
        return "";
    }
};

export function ArticleCard({ article }) {
    const dateLabel = formatArticleDate(article.published_at || article.updated_at);
    return (
        <Link className="lh-card" to={`/learning-hub/${article.slug}`}>
            <div className="lh-card-image-wrap">
                {article.cover_image_url ? (
                    <img
                        src={article.cover_image_url}
                        alt={article.cover_image_alt || article.title}
                        className="lh-card-image"
                        loading="lazy"
                    />
                ) : (
                    <div className="lh-card-image-placeholder" aria-hidden="true" />
                )}
            </div>
            <div className="lh-card-body">
                {dateLabel && <time className="lh-card-date">{dateLabel}</time>}
                {article.category?.name && (
                    <span className="lh-card-category">{article.category.name}</span>
                )}
                <h2 className="lh-card-title">{article.title}</h2>
                {article.summary && <p className="lh-card-summary">{article.summary}</p>}
            </div>
        </Link>
    );
}

export function FeaturedArticles({ articles }) {
    if (!articles?.length) {
        return null;
    }

    const [primary, ...rest] = articles;
    const secondary = rest.slice(0, 2);

    return (
        <section className="lh-featured" aria-label="Featured articles">
            <Link to={`/learning-hub/${primary.slug}`} className="lh-featured-main">
                <div className="lh-featured-image-wrap">
                    {primary.cover_image_url ? (
                        <img src={primary.cover_image_url} alt="" className="lh-featured-image" />
                    ) : (
                        <div className="lh-featured-image-placeholder" />
                    )}
                </div>
                <div className="lh-featured-main-body">
                    {primary.category?.name && (
                        <span className="lh-card-category">{primary.category.name}</span>
                    )}
                    <h2>{primary.title}</h2>
                    {primary.summary && <p>{primary.summary}</p>}
                </div>
            </Link>
            {secondary.length > 0 && (
                <div className="lh-featured-side">
                    {secondary.map((item) => (
                        <Link
                            key={item.slug}
                            to={`/learning-hub/${item.slug}`}
                            className="lh-featured-side-card"
                        >
                            <div className="lh-featured-side-image-wrap">
                                {item.cover_image_url ? (
                                    <img src={item.cover_image_url} alt="" />
                                ) : (
                                    <div className="lh-featured-image-placeholder" />
                                )}
                            </div>
                            <div>
                                {item.category?.name && (
                                    <span className="lh-card-category">{item.category.name}</span>
                                )}
                                <h3>{item.title}</h3>
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </section>
    );
}
